import { getTokenMsgArr } from "@/config/apiServe/fetch-config.js";
import { SearchDNS } from "../../config/apiServe/new-rpc";
import { filterAdrTag, checkIsEthAdr } from "@/utils/filters.js";
import { getAccountERC20Balances } from "../../config/apiServe/scanner";
import QRCode from "qrcodejs2";

export default {
    data() {
        return {
            code: {},
            baseCoin: require("../../assets/img/coin/baseCoin.png"),
            adrInfo: {
                adr: "",
                balance: 0,
                reciver: 0,
                txCount: 0,
                send: 0,
                dns: [],
            },
            contractInfo: [],
            contractSearch: "coins",
            totalValue: 0,
            tokenBalance: [],
            url: "",
        };
    },
    watch: {
        $route() {
            this.adrInfo = {
                adr: "",
                balance: 0,
                reciver: 0,
                txCount: 0,
                send: 0,
                dns: "",
            };
            this.tokenBalance = [];
            this.totalValue = 0;
            this.init();
            this.makeCode(checkIsEthAdr(this.$route.params.address));
        },
    },
    mounted() {
        this.init();
        this.drawCode(checkIsEthAdr(this.$route.params.address));
    },
    methods: {
        async init() {
            if (this.$route.params.address) {
                this.adrInfo.adr = checkIsEthAdr(this.$route.params.address);
                this.getAdrInfo(this.adrInfo.adr);
                this.getTokenAssets(this.adrInfo.adr);
                this.adrInfo.dns = (await this._searchDns(
                    this.$route.params.address
                )).filter((t) => t.slice(0, 4) == "bty.");
            } else {
                this.$notify({
                    title: this.$t("components.tip"),
                    message: this.$t("components.errParam"),
                    type: "warning",
                    duration: 1000,
                });
                this.$router.push({
                    path: "/",
                });
            }
        },
        isContact(adr) {
            return filterAdrTag(adr);
        },
        async _searchDns(adr) {
            const res = await SearchDNS(adr, 1);
            return res.data;
        },
        async getAdrInfo(adr) {
            const res = await this.Rpc.getAddrOverview(adr);
            if (res.error === null)
                this.adrInfo = {
                    ...this.adrInfo,
                    ...res.result,
                };
            this.adrInfo.send = this.adrInfo.reciver - this.adrInfo.balance;
            // 获取地址其他合约下的余额
            this.Rpc.getAllExecBalance(this.adrInfo.adr).then((data) => {
                if (data.error === null) {
                    this.contractInfo = data.result.execAccount;
                    if (this.contractInfo) {
                        this.contractInfo.forEach((item) => {
                            if (item.execer === "coins") {
                                this.adrInfo.balance =
                                    item.account.balance || 0;
                                this.adrInfo.frozen = item.account.frozen || 0;
                            }
                        });
                    } else
                        this.contractInfo = [
                            {
                                execer: "coins",
                                account: {
                                    balance: 0,
                                    frozen: 0,
                                    send: 0,
                                },
                            },
                        ];
                    if (
                        !JSON.stringify(this.contractInfo).includes(
                            '"execer":"coins"'
                        )
                    ) {
                        this.contractInfo = [
                            {
                                execer: "coins",
                                account: {
                                    balance: 0,
                                    frozen: 0,
                                },
                            },
                        ].concat(this.contractInfo);
                    }
                }
            });
        },
        // 查看指定合约下资产信息
        searchContract(ticket) {
            this.contractInfo.forEach((item) => {
                if (item.execer === ticket) {
                    this.adrInfo.balance = item.account.balance || 0;
                    this.adrInfo.frozen = item.account.frozen || 0;
                }
            });
        },
        // 获取地址下Token余额
        getTokenAssets(adr) {
            let infos = [];
            let tokens = [];
            getAccountERC20Balances(adr,{page: 1, size: 100}).then((data) => {
                if (data.code === 0) {
                    console.log(data,'ssss');
                    
                    data.data.tokens.map((current) => {
                        if (current.balance_formatted > 0) {
                            tokens.push(current.symbol);
                            infos.push({
                                contract_address: current.contract_address,
                                balance: current.balance_formatted,
                                symbol: current.symbol,
                                nickname: current.name,
                            });
                        }
                    });
                    this.tokenBalance = infos;
                    console.log(this.tokenBalance,'this.tokenBalance');
                    
                    // // this.tokenBalance = infos
                    // getTokenMsgArr(tokens, "bty").then((res) => {
                    //     res.data.map((current) => {
                    //         for (let i = 0; i < infos.length; i++) {
                    //             if (current.name === infos[i].symbol) {
                    //                 infos[i].icon =
                    //                     current.icon || this.baseCoin;
                    //                 infos[i].rmb = current.rmb || 0;
                    //                 infos[i].nickname =
                    //                     JSON.parse(current.nickname)[
                    //                         "zh-CN"
                    //                     ] === ""
                    //                         ? ""
                    //                         : JSON.parse(current.nickname)[
                    //                               "zh-CN"
                    //                           ];
                    //             }
                    //         }
                    //     });
                    //     infos.map((item) => {
                    //         this.totalValue += item.balance * item.rmb;
                    //     });
                    //     this.tokenBalance = infos;
                    // });
                } else return;
            });
        },
        drawCode(addr) {
            this.code = new QRCode("qrcode", {
                width: 100,
                height: 100,
                text: addr,
            });
            console.log(this.code);
        },
        makeCode(addr) {
            this.code.makeCode(addr);
        },
        downCode() {
            let imgs = document
                .getElementById("qrcode")
                .getElementsByTagName("img");
            let a = document.createElement("a");
            a.download = `code${new Date().getTime()}.png`;
            a.href = imgs[0].src;
            this.url = document
                .getElementById("qrcode")
                .getElementsByTagName("img")[0].src;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        success() {
            this.$message.success(this.$t("components.copySuc"));
        },
        error() {
            this.$message.warning(this.$t("components.copyErr"));
        },
    },
};
